module.exports = __webpack_public_path__ + "img/icon-mobile-app-inviter.f13c8dbd.svg";